/**
 * Notice for Controllers 스튜디오 — 문서 칸(fill) ↔ 기존 폼 모델(NoticeIndividual/CorporateFormModel) 양방향 동기화.
 *   모델이 단일 원본: e-Filing(ControllerAppointmentEFiling)·Edit 복원은 기존 빌더/스냅샷 형식 그대로 쓴다.
 *   · push(): 모델 → 문서 칸 (인물 선택·복원 직후 호출)
 *   · 문서 칸을 사용자가 고치면 → 모델 필드에 반영 (push 로 넣은 값과 같으면 무시)
 *   · display: 모델 값 대신 문서에 보일 문자열(예: 국적 코드 → 표시명, 연락처 합성)
 */
import { watch } from 'vue';

interface FillLike {
  values: Record<string, string>;
  getValue: (key: string) => string;
  setValue: (key: string, val: string) => void;
}

const st = (v: unknown) => (v == null ? '' : String(v).trim());

export function useNoticeStudioSync<M extends Record<string, any>>(
  fill: FillLike,
  model: M,
  map: Array<[string, keyof M & string]>,
  display: Partial<Record<string, (m: M) => string>> = {},
) {
  const lastPushed: Record<string, string> = {};

  function push() {
    for (const [k, f] of map) {
      const fn = display[k];
      const v = fn ? st(fn(model)) : st(model[f]);
      lastPushed[k] = v;
      if (v !== st(fill.getValue(k))) fill.setValue(k, v);
    }
  }

  watch(
    () => map.map(([k]) => fill.values[k]),
    (vals) => {
      map.forEach(([k, f], i) => {
        const v = st(vals[i]);
        if (v === (lastPushed[k] ?? st(model[f]))) return;
        lastPushed[k] = v;
        (model as Record<string, any>)[f] = v;
      });
    },
  );

  return { push };
}
